/** Keys must match backend / serve paths exactly */
export const BANNER_PLACEMENT_KEYS = [
  'arcade_quiz',
  'arcade_fanwars',
  'arcade_prediction',
  'arcade_mind_cricket',
  'arcade_homepage',
  'reels',
  'homepage_cheer_meter',
  'homepage_banner',
  'match_wall_fan_journey_banner'
];

export const BANNER_PLACEMENT_LABELS = {
  arcade_quiz: 'Arcade – quiz / FPL / predictions (bottom)',
  arcade_fanwars: 'Arcade – Fanwars',
  arcade_prediction: 'Arcade – Prediction',
  arcade_mind_cricket: 'Arcade – Mind cricket (bottom)',
  arcade_homepage: 'Arcade – homepage',
  reels: 'Reels (between reels)',
  homepage_cheer_meter: 'Home – cheer meter (between carousels)',
  homepage_banner: 'Home – banner',
  match_wall_fan_journey_banner: 'Match wall – fan journey banner',
};

export function emptyPlacementFields() {
  return BANNER_PLACEMENT_KEYS.reduce((acc, key) => {
    acc[key] = { image_url: '', redirection_url: '', enabled: false };
    return acc;
  }, {});
}

export function normalizePlacementsFromApi(placements) {
  const src = placements && typeof placements === 'object' ? placements : {};
  return BANNER_PLACEMENT_KEYS.reduce((acc, key) => {
    const slot = src[key];
    const image_url = (slot && slot.image_url) || '';
    const redirection_url = (slot && slot.redirection_url) || '';
    const img = image_url.trim();
    const url = redirection_url.trim();
    acc[key] = {
      image_url,
      redirection_url,
      /** Active when API returned a full slot; user can turn off to drop the key on save */
      enabled: Boolean(img && url)
    };
    return acc;
  }, {});
}

export function buildPlacementsPayload(placementFields) {
  const out = {};
  BANNER_PLACEMENT_KEYS.forEach((key) => {
    const p = placementFields[key];
    if (!p || !p.enabled) return;
    const img = (p.image_url || '').trim();
    const url = (p.redirection_url || '').trim();
    if (img && url) {
      out[key] = { image_url: img, redirection_url: url };
    }
  });
  return out;
}

/** Count placement slots on an API row that have both URLs */
export function countActivePlacementsFromApi(placements) {
  if (!placements || typeof placements !== 'object') return 0;
  return Object.keys(buildPlacementsPayload(normalizePlacementsFromApi(placements))).length;
}
